<div class="platform-page-container">
  <div class="platform-header-container">
    <markant-platform-header class="header"></markant-platform-header>
  </div>

  <div class="platform-main">
    @if ($showNavigation()) {
      <div class="platform-sidebar">
        <markant-platform-navigation></markant-platform-navigation>
      </div>
    }

    <!-- scrollable content -->
    <div class="platform-content-container">
      <div
        class="platform-content"
        [class.no-padding]="$noPadding()"
        [class.profile-height]="$isProfilePage()"
      >
        <router-outlet></router-outlet>
      </div>

      <div class="platform-footer">
        <markant-platform-support-button></markant-platform-support-button>
        <markant-platform-footer></markant-platform-footer>
      </div>
    </div>
  </div>

  <markant-platform-oa-admin-area-guide></markant-platform-oa-admin-area-guide>
</div>
